'use client'

import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Components } from 'react-markdown'

const components: Components = {
  h2: ({ children }) => (
    <h2
      style={{
        fontSize: '1.25rem',
        fontWeight: 700,
        color: '#111827',
        marginTop: '2rem',
        marginBottom: '1rem',
        paddingBottom: '0.5rem',
        borderBottom: '1px solid #e5e7eb',
      }}
    >
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3
      style={{
        fontSize: '1.1rem',
        fontWeight: 600,
        color: '#1f2937',
        marginTop: '1.5rem',
        marginBottom: '0.75rem',
      }}
    >
      {children}
    </h3>
  ),
  p: ({ children }) => (
    <p style={{ color: '#374151', lineHeight: 1.7, marginBottom: '0.75rem' }}>{children}</p>
  ),
  strong: ({ children }) => <strong style={{ color: '#111827' }}>{children}</strong>,
  a: ({ href, children }) => (
    <a
      href={href}
      style={{ color: '#2563eb', textDecoration: 'none' }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  ),
  ul: ({ children }) => (
    <ul style={{ listStyleType: 'disc', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
      {children}
    </ul>
  ),
  ol: ({ children }) => (
    <ol style={{ listStyleType: 'decimal', paddingLeft: '1.5rem', marginBottom: '1rem' }}>
      {children}
    </ol>
  ),
  li: ({ children }) => (
    <li style={{ color: '#374151', lineHeight: 1.7, marginBottom: '0.25rem' }}>{children}</li>
  ),
  hr: () => <hr style={{ margin: '1.5rem 0', borderColor: '#e5e7eb' }} />,
  table: ({ children }) => (
    <div style={{ overflowX: 'auto', marginBottom: '1rem' }}>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontSize: '0.9rem',
          border: '1px solid #d1d5db',
        }}
      >
        {children}
      </table>
    </div>
  ),
  thead: ({ children }) => <thead style={{ backgroundColor: '#f9fafb' }}>{children}</thead>,
  th: ({ children }) => (
    <th
      style={{
        textAlign: 'left',
        fontWeight: 600,
        color: '#374151',
        padding: '0.625rem 0.75rem',
        border: '1px solid #d1d5db',
        backgroundColor: '#f9fafb',
      }}
    >
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td
      style={{
        padding: '0.625rem 0.75rem',
        border: '1px solid #d1d5db',
        verticalAlign: 'top',
        color: '#374151',
      }}
    >
      {children}
    </td>
  ),
  blockquote: ({ children }) => (
    <blockquote
      style={{
        borderLeft: '3px solid #d1d5db',
        paddingLeft: '1rem',
        margin: '1rem 0',
        color: '#6b7280',
      }}
    >
      {children}
    </blockquote>
  ),
}

export function LegalMarkdown({ content }: { content: string }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {content}
    </ReactMarkdown>
  )
}
